// react
import React, { useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectShoppingCart, resetShoppingCart } from '_redux/slices/marketplace/user-marketplace';

// custom components
import { CartCard } from '_components/molecules';

// styles
import { Colors, Spacing } from '_styles';
import { FaShoppingCart } from 'react-icons/fa';

// nav
import { useHistory } from 'react-router-dom';

const ShoppingCart = ({showModal, setShowModal}) => {

    // nav
    const history = useHistory();

    // redux
    const dispatch = useDispatch();
    const cart = useSelector(selectShoppingCart) || {};

    // local states
    //const [showModal, setShowModal] = useState(false);
    //const totalQuantity = Object.values(cart).reduce((sum, item) => sum + (item.quantity || 0), 0);

    const handleClear = () => {
        history.push('/')
        dispatch(resetShoppingCart())
    }

    const styles = {
        wrapper: { position: 'relative' },
        icon: {
            fontSize: 32,
            color: '#fff',
            cursor: 'pointer',
        },
        bubble: {
            position: 'absolute',
            top: -Spacing.SCALE_6,
            right: -Spacing.SCALE_6,
            backgroundColor: Colors.PRM_LIGHT_BLUE,
            color: '#fff',
            borderRadius: '50%',
            width: Spacing.SCALE_20,
            height: Spacing.SCALE_20,
            fontSize: 12,
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
        },
        modal: {
            position: 'fixed',
            top: '15%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: "100%",
            backgroundColor: Colors.GRAY_LIGHT,
            borderRadius: Spacing.SCALE_10,
            // boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            zIndex: 1000,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        },
        modalHeader: {
            padding: `${Spacing.SCALE_12}px ${Spacing.SCALE_16}px`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: `1px solid ${Colors.GRAY_LIGHT}`,
            backgroundColor: Colors.GRAY_LIGHT,
        },
        modalTitle: {
            margin: 0,
            fontSize: 24,
            fontWeight: 'bold',
            color: Colors.TEXT_COLOR,
        },
        closeButton: {
            cursor: 'pointer',
            fontSize: 24,
            border: 'none',
            background: 'none',
            color: Colors.GRAY_DARK,
        },
        modalContent: {
            padding: Spacing.SCALE_16,
            maxHeight: Spacing.SCALE_500,
            overflowY: 'auto',
        },
        buttonWrapper: {
            display: 'flex',
            gap: 20,
            justifyContent: 'center',
            padding: `${Spacing.SCALE_12}px 0 ${Spacing.SCALE_16}px 0`,
        },
        button: {
            padding: `${Spacing.SCALE_8}px ${Spacing.SCALE_12}px`,
            color: '#fff',
            border: 'none',
            borderRadius: Spacing.SCALE_6,
            cursor: 'pointer',
            fontWeight: 'bold',
            minWidth: Spacing.SCALE_120,
            textAlign: 'center',
        },
        backdrop: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
        },
    };

    return (
        <div style={styles.wrapper}>

            {showModal && (
                <>
                    <div style={styles.backdrop} onClick={() => setShowModal(false)} />
                    <div style={styles.modal}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>Shopping Cart</h3>
                            <button style={styles.closeButton} onClick={() => setShowModal(false)}>
                                &times;
                            </button>
                        </div>
                        <div style={styles.modalContent}>
                            {Object.values(cart).length > 0 ? (
                                Object.values(cart).map((item) => (
                                    <CartCard key={item.id} item={item} />
                                ))
                            ) : (
                                <div style={{ display:'flex', alignItems:'center', justifyContent:'center'}}>
                                    <p style={{ color: 'black', opacity:0.8 }}>Your cart is empty.</p>
                                </div>
                            )}
                        </div>

                        {/* Only show Clear Cart if items exist */}
                        {Object.values(cart).length > 0 && (
                            <div style={styles.buttonWrapper}>
                                <button
                                    style={{ ...styles.button, backgroundColor: Colors.DARK_RED }}
                                    onClick={() => dispatch(resetShoppingCart())}
                                >
                                    Clear Cart
                                </button>

                                <button
                                    style={{ ...styles.button, backgroundColor: Colors.PRM_LIGHT_BLUE }}
                                    onClick={() => history.push('/checkout')}
                                >
                                    Checkout
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default ShoppingCart;
